import InmuebleQYRTemplate from "../../components/templates/inmuebles/InmuebleQYRTemplate"

const InmuebleQYR = () => {
    return <InmuebleQYRTemplate/>;
};

export default InmuebleQYR;